import GlobalSearch from '../GlobalSearch'

const OuterSearchMenuItem = () => {
    return (
        <GlobalSearch
            variant="outer"
            className="mw-100"
        />
    )
}

export default OuterSearchMenuItem
